module.exports = __webpack_public_path__ + "img/SWP_Staff_2H_06 (2).90bdd30b.png";